module.exports = __webpack_public_path__ + "img/again.0ed24c5a.png";